import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import * as THREE from 'three';

import { CSS3DRenderer, CSS3DObject } from './CSS3DRenderer';
import {} from '../style/projects_viewer.css';

import image from '../img/thumb/cards_ui.png';
import OBJLoader from 'three-react-obj-loader';
import model0 from '../models/termite_case.obj';
import content from '../content';

import Modal from "../Modal";
import arrow_bg from "../svg/arrow_left.svg";
import arrow_thumb from "../svg/arrow_thumb.svg";

let renderer, scene, animation, camera, renderer2d, scene2d;
let mouse = {
	on: false,
	origin: { x: 0, y: 0 },
	x: 0,
	y: 0,
	delta: { x: 0, y: 0 },
	_delta: { x: 0, y: 0 }
};
let cameraPosX = 0;
let delta = 0;
var smoothInterval;
let alpha = 0;
var clock = new THREE.Clock();
var TWEEN = require('@tweenjs/tween.js');
let objLoader = new OBJLoader();
let mainModel = null;

/*limits*/
let limitLeft = -500;
let limitRight = 2300;

class ProjectCard extends Component {
	constructor(props) {
		super(props);

	}

	render() {
		var { type, title, text, image, year } = this.props;

		return (
			<div className="project-card" onClick={this.props.onClickProject}>
				<div className="project-card-content">
					<div className="project-card-type">{type}</div>
					<div className="project-card-divider" />
					<div className="project-card-title">{title}</div>
					<div className="project-card-text">{text}</div>
					<div className="project-card-year">{year}</div>
				</div>
			</div>
		);
	}
}

export default class ProjectsViewer extends Component {
	constructor(props) {
		super(props);
		this.init = this.init.bind(this);
		this.animate = this.animate.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.update = this.update.bind(this);

		this.onMouseMove = this.onMouseMove.bind(this);
		this.onMouseUp = this.onMouseUp.bind(this);

		this.onTouchMove = this.onTouchMove.bind(this);
		this.onTouchUp = this.onTouchUp.bind(this);

		this.createProjects = this.createProjects.bind(this);
		this.onClickProject = this.onClickProject.bind(this);

		document.addEventListener('keydown', this.onKeyDown);

		document.addEventListener('mousedown', this.onMouseDown.bind(this));
		document.addEventListener('mouseup', this.onMouseUp.bind(this));
		document.addEventListener('mousemove', this.onMouseMove2.bind(this));

		document.addEventListener('touchstart',this.onTouchDown.bind(this));
		document.addEventListener('touchend', this.onTouchUp.bind(this));
		//document.addEventListener('touchmove', this.onMouseMove2.bind(this));

		window.addEventListener('resize', this.updateDimensions.bind(this));
		
		this.state={
			started: false
		}
	}

	onMouseDown(event) {
		event.preventDefault();
		mouse.on = true;
		mouse.origin = { x: event.clientX, y: event.clientY };
		document.addEventListener('mousemove', this.onMouseMove);
		
		this.setState({started:true});
	}

	onTouchDown(event){
		//console.log("touch", event);
		mouse.on = true;
		mouse.origin = { x: event.touches[0].clientX, y: event.touches[0].clientY};
		document.addEventListener('touchmove', this.onTouchMove);
		TWEEN.removeAll();

		this.setState({started:true});
	}

	onMouseUp(event) {
		mouse.on = false;
		//
		document.removeEventListener('mousemove', this.onMouseMove);
		//document.removeEventListener('touchmove', this.onMouseMove);

		var position = { x: mouse.delta.x, y: mouse.delta.y };

		var target;
		target = { x: mouse._delta.y*0.01, y: mouse.delta.y };

		//mouse.delta.x = 0;
		//mouse.delta.y = 0;

		if (Math.abs(mouse.origin.x - event.clientX) > 10) {
			var tween = new TWEEN.Tween(position).to(target, 1000);
			tween.onUpdate(function(d) {
				//console.log('tween', d);
				mouse.delta = d;
			});

			tween.easing(TWEEN.Easing.Quadratic.Out);
			tween.start();
		}

		mouse.origin = { x: event.clientX, y: event.clientY };
	}

	onTouchUp(event){
		mouse.on = false;
		//
		//document.removeEventListener('mousemove', this.onMouseMove);
		document.removeEventListener('touchmove', this.onMouseMove);

		var position = { x: mouse.delta.x, y: mouse.delta.y };

		var target;
		target = { x: 0, y: mouse.delta.y };

		console.log("touch", event);
		
		//if(event.touches.length>0)
		//if (Math.abs(mouse.origin.x - event.touches[0].clientX) > 10) {
			var tween = new TWEEN.Tween(position).to(target, 2000);
			tween.onUpdate(function(d) {
				//console.log('tween', d);
				mouse.delta = d;
			});

			tween.easing(TWEEN.Easing.Quadratic.Out);
			tween.start();
		//}

		//mouse.origin = { x: event.touches[0].clientX, y: event.touches[0].clientY };
	}

	onMouseMove(event) {
		
		event.preventDefault();
		//if (mouse.on) {
		mouse.x = event.clientX;
		mouse.y = event.clientY;
		
		mouse._delta.x = mouse.origin.x - mouse.x > 0 ? 1 : -1;
		mouse._delta.y = mouse.y - mouse.y;

		var delta_x = mouse.delta.x;
		
		mouse.delta.x += (mouse.origin.x - mouse.x) / window.innerWidth;
		
		mouse.delta.y += mouse.origin.y - mouse.y;

		

		if (mouse.origin.x == mouse.x) {
			mouse._delta.x = 0;
		}

		//console.log('mouse', mouse);
	}

	onTouchMove(event){
		event.preventDefault();
		//if (mouse.on) {
		mouse.x = event.touches[0].clientX;
		mouse.y = event.touches[0].clientY;
		
		mouse._delta.x = mouse.origin.x - mouse.x > 0 ? 1 : -1;
		mouse._delta.y = mouse.y - mouse.y;

		var delta_x = mouse.delta.x;
		
		mouse.delta.x += (mouse.origin.x - mouse.x) / window.innerWidth;
		
		mouse.delta.y += mouse.origin.y - mouse.y;

		if (mouse.origin.x == mouse.x) {
			mouse._delta.x = 0;
		}

	}

	onMouseMove2(event) {
		mouse.x = event.clientX;
		mouse.y = event.clientY;
	}

	componentDidMount() {
		this.init();
	}

	onKeyDown(event) {
		var key = event.key;
		if (key == 'ArrowRight') {
		} else if (key == 'ArrowLeft') {
		}
	}

	createProjects() {
		var gridSize = 300;
		var rowSize = 80;
		var imgSize = 150;

		content.map((project, index) => {
			//HTML card
			var card_element = document.createElement('div');
			var card_jsx = (
				<div onClick={()=>this.onClickProject(project)}>
				<ProjectCard
					title={project.title.toUpperCase()}
					type={project.type}
					text={project.text}
					year={project.year}
					
				/>
				</div>
			);
			ReactDOM.render(card_jsx, card_element);
			var card = new CSS3DObject(card_element);
			card.position.x = 10 + gridSize*project.grid.x;
			card.position.y = rowSize*project.grid.y;
			card.position.z = 20;
		
			scene2d.add(card);

			//HTML image
			var image_element = document.createElement('div');
			var img_jsx = (
				<div onClick={()=>this.onClickProject(project)}>
				<img src={project.image} height={imgSize * project.size} className="project-image"/>
				</div>
			);

			ReactDOM.render(img_jsx, image_element);

			var image = new CSS3DObject(image_element);
			image.position.x = -100 + gridSize*project.grid.x;
			image.position.y = rowSize*project.grid.y;
			image.position.z = -100;
			
			//div2.rotation.x = Math.PI *0.12;
			scene2d.add(image);

		});
		/*
		var element2 = document.createElement('div');

		ReactDOM.render(i, element2);

		var div2 = new CSS3DObject(element2);
		div2.position.x = -100;
		div2.position.y = 0;
		div2.position.z = -20;

		//div2.rotation.x = Math.PI *0.12;
		scene2d.add(div2);
		*/
	}
	async init() {
		const width = window.innerWidth;
		const height = window.innerHeight - (this.props.marginTop ? this.props.marginTop : 0);

		const canvas = this.refs.threeCanvas;
		canvas.height = height;
		canvas.width = width;
		

		const canvas2d = this.refs.canvas2d;
		//canvas2d.width = width;
		//canvas2d.height = height;
		
		canvas2d.style.width = width + 'px';
		canvas2d.style.height = height + 'px';

		scene = new THREE.Scene();
		camera = new THREE.PerspectiveCamera(45, width / height, 0.01, 10000);
		//camera = new THREE.PerspectiveCamera(50, width / height, 1, 1000);
		camera.position.set(-100, 0, 600);

		renderer = new THREE.WebGLRenderer({
			canvas: canvas,
			antialias: true,
			alpha: true,
			opacity: 1.0
		});

		renderer.shadowMap.enabled = true;
		renderer.shadowMap.type = THREE.PCFSoftShadowMap;

		//CSS3D Scene
		scene2d = new THREE.Scene();

		renderer2d = new CSS3DRenderer(this.refs.canvas2d);
		renderer2d.setSize(width, height);

		var geometry = new THREE.BoxGeometry(100, 100, 100);
		var material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
		var cube = new THREE.Mesh(geometry, material);
		// /scene.add(cube);
		this.createProjects();

		/*loading 3d models*/
		//only if it's desktop
		if(window.innerWidth>=600)
		objLoader.load(model0, function(model) {

			console.log('model', model);
			//changing model material
			var material = new THREE.MeshBasicMaterial({
				color: 0xa0a0a0,
				wireframe: true,
				transparent: true,
				opacity: 0.1
			});

			model.material = material;

			model.castShadow = true;
			model.receiveShadow = true;
			model.scale.set(70, 70, 70);
			model.position.set(0, 0, -800);

			model.traverse(function(child) {
				if (child instanceof THREE.Mesh) {
					child.material = material;
					child.castShadow = true;
					child.receiveShadow = true;
				}
				child.traverse(function(c) {
					c.material = material;
					c.castShadow = true;
					c.receiveShadow = true;
				});
			});
			mainModel = model;

			scene.add(mainModel);
		});

		
		mouse.delta.x = 0.25;
		this.animate();
	}

	animate() {
		animation = requestAnimationFrame(this.animate);
		this.update();
		renderer2d.render(scene2d, camera);
		renderer.render(scene, camera);
	}

	update() {
		delta += clock.getDelta();
		TWEEN.update();
		

		if (camera.position.x < limitLeft) {
			mouse.delta.x = 0;
			TWEEN.removeAll();
			camera.position.x = limitLeft;
		} else if (camera.position.x > limitRight) {
			mouse.delta.x = 0;
			camera.position.x = limitRight;
			TWEEN.removeAll();
		}
		else{
			camera.position.x += mouse.delta.x *0.5;
		}

		if (mainModel) {
			mainModel.rotation.y = 0.01 * delta;
			mainModel.rotation.x = 0.00005 * mouse.y ;
		}

		//if(camera.position.x < 50 || mouse._delta.x < 0)
		// + delta *2;
		//camera.position.x = mouse.delta.x * 14.0 + alpha * delta + delta * 3;
	}

	updateDimensions() {
		//Get the proportions from screen
		const width = window.innerWidth;
		const height = window.innerHeight - (this.props.marginTop ? this.props.marginTop : 0);

		var canvas = this.refs.threeCanvas;
		canvas.width = width;
		canvas.height = height;

		renderer.setSize(width, height);
		renderer.setPixelRatio( window.devicePixelRatio );
		renderer2d.setSize(width, height);
		//renderer2d.setPixelRatio( window.devicePixelRatio );
		camera.aspect = width / height;

		camera.updateProjectionMatrix();
	}

	onClickProject(project){
		if(this.props.openModal){
			this.props.openModal(project);
		}
	}

	render() {
		return (
			<div>
			<div ref="rootthree" className="canvas">

			<div className={this.state.started?"arrow-start arrow-start-end" : "arrow-start"}>
			<img src={arrow_bg} clasName="arrow-background"/>
			<img src={arrow_thumb} className="arrow-thumb"/>
		</div>

				<canvas ref="threeCanvas" className="canvas3d" />
				<div ref="canvas2d" className="canvas2d" />

				

				
			</div>
			
			</div>
			
		);
	}
}



// WEBPACK FOOTER //
// ./src/3d/ProjectsViewer.jsx